import { createApp, ref } from 'vue';
import { useHeader } from '@components/shared/elements/header';
import SearchBox from '@/components/shared/search-box.vue';
import { useFlashMessage } from '@components/shared/elements/flash_message';

const header = createApp({
  setup() {
    const { headerData, headerFunction } = useHeader();

    return {
      ...headerData,
      ...headerFunction,
    };
  },
});

const flashMessage = createApp({
  setup() {
    const { flash } = useFlashMessage();

    return {
      flash,
    };
  },
});

header.component('SearchBox', SearchBox);

document.addEventListener('DOMContentLoaded', () => {
  header.mount('.c-shared-elements-header');

  const flashMessageElement = document.querySelector(
    '.c-shared-elements-flashmessage'
  );
  if (flashMessageElement) flashMessage.mount(flashMessageElement);
});
